import { Routes, Route, Navigate } from "react-router-dom";
import React, { Suspense, lazy, Fragment } from "react";
import Loader from "react-loaders";
import { ToastContainer } from "react-toastify";
import SafeRoute from "../../pages/safe-route/SafeRoute.js";

// Real app
// const Dashboard = lazy(() => import("../../pages/dashboard/index"));
const CategoryContent = lazy(() => import("../../pages/category/index"));
const ColorContent = lazy(() => import("../../pages/colors/index"));
const SizeContent = lazy(() => import("../../pages/sizes/index"));
const MaterialContent = lazy(() => import("../../pages/material/index.js"));
const ProductContent = lazy(() => import("../../pages/product/index"));
const OrdersContent = lazy(() => import("../../pages/orders/index"));
const PaymentSettingsPage = lazy(() => import("../../pages/paymentSettings/index"));
// const Financial = lazy(() => import("../../pages/financial/index"));
const Login = lazy(() => import("../../pages/login/Login.jsx"));
// Real app

const AppMain = () => {
  return (
    <Fragment>
      <Routes>
        <Route path="/" element={<Navigate to="/app/category" />} />

        {/* Dashboard */}
        {/* <Route
          path="/app/dashboard/*"
          element={
            <Suspense
              fallback={
                <div className="loader-container">
                  <div className="loader-container-inner">
                    <div className="text-center">
                      <Loader type="ball-grid-cy" />
                    </div>
                    <h6 className="mt-3">
                      Please wait while the dashboard loads
                      <small>You are loved! {"<3"}</small>
                    </h6>
                  </div>
                </div>
              }
            >
              <SafeRoute>
                <Dashboard />
              </SafeRoute>
            </Suspense>
          }
        /> */}

        {/* Category */}
        <Route
          path="/app/category/*"
          element={
            <Suspense
              fallback={
                <div className="loader-container">
                  <div className="loader-container-inner">
                    <div className="text-center">
                      <Loader type="ball-grid-cy" />
                    </div>
                    <h6 className="mt-3">
                      Please wait while the category section loads
                      <small>You are loved! {"<3"}</small>
                    </h6>
                  </div>
                </div>
              }
            >
              <SafeRoute>
                <CategoryContent />
              </SafeRoute>
            </Suspense>
          }
        />

        {/* Color */}
        <Route
          path="/app/color/*"
          element={
            <Suspense
              fallback={
                <div className="loader-container">
                  <div className="loader-container-inner">
                    <div className="text-center">
                      <Loader type="ball-grid-cy" />
                    </div>
                    <h6 className="mt-3">
                      Please wait while the color section loads
                      <small>You are loved! {"<3"}</small>
                    </h6>
                  </div>
                </div>
              }
            >
              <SafeRoute>
                <ColorContent />
              </SafeRoute>
            </Suspense>
          }
        />

        {/* Size */}
        <Route
          path="/app/size/*"
          element={
            <Suspense
              fallback={
                <div className="loader-container">
                  <div className="loader-container-inner">
                    <div className="text-center">
                      <Loader type="ball-grid-cy" />
                    </div>
                    <h6 className="mt-3">
                      Please wait while the size section loads
                      <small>You are loved! {"<3"}</small>
                    </h6>
                  </div>
                </div>
              }
            >
              <SafeRoute>
                <SizeContent />
              </SafeRoute>
            </Suspense>
          }
        />

        {/* Material */}
        <Route
          path="/app/material/*"
          element={
            <Suspense
              fallback={
                <div className="loader-container">
                  <div className="loader-container-inner">
                    <div className="text-center">
                      <Loader type="ball-grid-cy" />
                    </div>
                    <h6 className="mt-3">
                      Please wait while the material section loads
                      <small>You are loved! {"<3"}</small>
                    </h6>
                  </div>
                </div>
              }
            >
              <SafeRoute>
                <MaterialContent />
              </SafeRoute>
            </Suspense>
          }
        />

        {/* Product */}
        <Route
          path="/app/product/*"
          element={
            <Suspense
              fallback={
                <div className="loader-container">
                  <div className="loader-container-inner">
                    <div className="text-center">
                      <Loader type="ball-grid-cy" />
                    </div>
                    <h6 className="mt-3">
                      Please wait while the product section loads
                      <small>You are loved! {"<3"}</small>
                    </h6>
                  </div>
                </div>
              }
            >
              <SafeRoute>
                <ProductContent />
              </SafeRoute>
            </Suspense>
          }
        />

        {/* Order */}
        <Route
          path="/app/orders/*"
          element={
            <Suspense
              fallback={
                <div className="loader-container">
                  <div className="loader-container-inner">
                    <div className="text-center">
                      <Loader type="ball-grid-cy" />
                    </div>
                    <h6 className="mt-3">
                      Please wait while the orders section loads
                      <small>You are loved! {"<3"}</small>
                    </h6>
                  </div>
                </div>
              }
            >
              <OrdersContent />
            </Suspense>
          }
        />

        {/* Payment Settings */}
        <Route
          path="/app/payment-settings/*"
          element={
            <Suspense
              fallback={
                <div className="loader-container">
                  <div className="loader-container-inner">
                    <div className="text-center">
                      <Loader type="ball-grid-cy" />
                    </div>
                    <h6 className="mt-3">
                      Please wait while payment settings load
                      <small>You are loved! {"<3"}</small>
                    </h6>
                  </div>
                </div>
              }
            >
              <SafeRoute>
                <PaymentSettingsPage />
              </SafeRoute>
            </Suspense>
          }
        />

        {/* Financial */}
        {/* <Route
          path="/app/financial/*"
          element={
            <Suspense
              fallback={
                <div className="loader-container">
                  <div className="loader-container-inner">
                    <div className="text-center">
                      <Loader type="ball-grid-cy" />
                    </div>
                    <h6 className="mt-3">
                      Please wait while the financial stats section loads
                      <small>You are loved! {"<3"}</small>
                    </h6>
                  </div>
                </div>
              }
            >
              <SafeRoute>
                <Financial />
              </SafeRoute>
            </Suspense>
          }
        /> */}

        {/* Login */}
        <Route
          path="/login/"
          element={
            <Suspense
              fallback={
                <div className="loader-container">
                  <div className="loader-container-inner">
                    <div className="text-center">
                      <Loader type="ball-grid-cy" />
                    </div>
                    <h6 className="mt-3">
                      Please wait while the login page loads
                      <small>You are loved! {"<3"}</small>
                    </h6>
                  </div>
                </div>
              }
            >
              <SafeRoute>
                <Login />
              </SafeRoute>
            </Suspense>
          }
        />
      </Routes>
      <ToastContainer />
    </Fragment>
  );
};

export default AppMain;
